/**
 * @module ServiceTestsScheduleConstants
 * @description Phase 11 extraction of shared schedule types, validation keys, and interval presets.
 * Used by schedule generators, transforms, and the compatibility helper barrel.
 */

// Schedule type constants — match the API `type` field values
export const INTERVAL = 'interval';
export const DAILY = 'daily';
export const WINDOW = 'window';

// Validation error keys — used by dialog to map to translated strings
export const SCHEDULE_ERROR_KEYS = {
    DAILY_START_REQUIRED: 'DAILY_START_REQUIRED',
    INTERVAL_REQUIRED: 'INTERVAL_REQUIRED',
    WINDOW_START_REQUIRED: 'WINDOW_START_REQUIRED',
    WINDOW_END_REQUIRED: 'WINDOW_END_REQUIRED',
    WINDOW_END_SAME_AS_START: 'WINDOW_END_SAME_AS_START',
};

export const DEFAULT_INTERVAL_SECONDS = 600;

export const DEFAULT_MAX_INTERVAL_SECONDS = 86400;

// All possible test intervals (sourced from node-utility/lib/utils/Constants.js)
export const ALL_TEST_INTERVALS = [
    { value: 60, text: '1 minute' },
    { value: 120, text: '2 minutes' },
    { value: 300, text: '5 minutes' },
    { value: 600, text: '10 minutes' },
    { value: 900, text: '15 minutes' },
    { value: 1200, text: '20 minutes' },
    { value: 1800, text: '30 minutes' },
    { value: 2700, text: '45 minutes' },
    { value: 3600, text: '1 hour' },
    { value: 7200, text: '2 hours' },
    { value: 14400, text: '4 hours' },
    { value: 28800, text: '8 hours' },
    { value: 43200, text: '12 hours' },
    { value: 86400, text: '24 hours' },
];

// Schedule type display format strings — consumed by ScheduleFormatters.formatScheduleType()
export const INTERVAL_TYPE_FORMAT = 'Interval';
export const DAILY_TYPE_FORMAT = 'Daily';
